import { jsx as n } from "react/jsx-runtime";
import { SkeletonText as a } from "@chakra-ui/react";
import { ThemeColorVariable as e } from "../../theme/theme-types.js";
function l({
  startColor: o = e.BackgroundDisabled,
  endColor: r = e.OnBackgroundBorder,
  ...t
}) {
  return /* @__PURE__ */ n(
    a,
    {
      speed: 0.8,
      fadeDuration: 0.4,
      startColor: o,
      endColor: r,
      ...t
    }
  );
}
export {
  l as SkeletonText
};
